// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Container } from 'react-bootstrap';

/**
 * ProtectedRoute wrapper component that requires authentication
 * Redirects to /login if user is not authenticated
 * Shows loading state while checking auth status
 *
 * Future enhancement: Can add role-based access control or approval checks here
 */
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="text-white">Loading...</div>
      </Container>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Future: Add approval check for external users
  // if (user?.user_metadata?.requires_approval && !user?.user_metadata?.approved) {
  //   return <Navigate to="/pending-approval" replace />;
  // }

  // User is authenticated, render the protected content
  return children;
}

export default ProtectedRoute;
